import facepaint from 'facepaint';
var gs = function gs(times) {
  return "".concat(8 * times, "px");
};
var br = function br() {
  var times = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return "".concat(3 * times, "px");
};
var mq = facepaint(['@media(min-width: 576px)']);
export { gs, br, mq };